
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const categories = [
  {
    icon: 'ri-windows-line',
    title: 'Sistemas Operativos',
    brand: 'Microsoft Windows',
    image: 'https://readdy.ai/api/search-image?query=modern%20Windows%2011%20operating%20system%20interface%20on%20a%20sleek%20monitor%20screen%2C%20dark%20minimal%20background%20with%20subtle%20cyan%20glow%2C%20professional%20IT%20setup%2C%20clean%20technology%20aesthetic&width=600&height=400&seq=sw-cat-1&orientation=landscape',
    items: [
      'Windows 11 Pro',
      'Windows 11 Home',
      'Windows 10 Pro',
      'Windows Server 2022',
      'Windows Server 2019',
    ],
    description: 'Licencias originales de Windows para estaciones de trabajo y servidores empresariales con activación permanente.',
  },
  {
    icon: 'ri-file-word-line',
    title: 'Ofimática',
    brand: 'Microsoft Office',
    image: 'https://readdy.ai/api/search-image?query=Microsoft%20Office%20suite%20applications%20Word%20Excel%20PowerPoint%20icons%20on%20a%20dark%20modern%20desktop%20screen%2C%20subtle%20teal%20neon%20lighting%2C%20professional%20workspace%2C%20clean%20minimal%20dark%20background&width=600&height=400&seq=sw-cat-2&orientation=landscape',
    items: [
      'Microsoft 365 Business',
      'Microsoft 365 Enterprise',
      'Office 2024 Professional',
      'Office 2021 LTSC',
      'Visio / Project',
    ],
    description: 'Suite completa de productividad con Word, Excel, PowerPoint, Outlook y herramientas colaborativas en la nube.',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Seguridad',
    brand: 'Antivirus & Protección',
    image: 'https://readdy.ai/api/search-image?query=cybersecurity%20shield%20protection%20software%20interface%20on%20dark%20screen%2C%20digital%20lock%20and%20firewall%20visualization%2C%20subtle%20cyan%20neon%20accents%2C%20professional%20dark%20minimal%20background%2C%20technology%20security%20concept&width=600&height=400&seq=sw-cat-3&orientation=landscape',
    items: [
      'ESET NOD32 / Smart Security',
      'Kaspersky Endpoint Security',
      'Bitdefender GravityZone',
      'Norton 360 Business',
      'Malwarebytes Premium',
    ],
    description: 'Soluciones de ciberseguridad empresarial con protección en tiempo real, firewall avanzado y gestión centralizada.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Servidores & Backup',
    brand: 'Infraestructura IT',
    image: 'https://readdy.ai/api/search-image?query=server%20rack%20with%20backup%20storage%20systems%20in%20a%20dark%20data%20center%20room%2C%20subtle%20cyan%20LED%20lighting%2C%20professional%20IT%20infrastructure%2C%20clean%20modern%20technology%20environment%2C%20dark%20minimal%20background&width=600&height=400&seq=sw-cat-4&orientation=landscape',
    items: [
      'SQL Server Standard / Enterprise',
      'Veeam Backup & Replication',
      'Acronis Cyber Protect',
      'VMware vSphere',
      'Hyper-V Server',
    ],
    description: 'Licencias para servidores de bases de datos, virtualización y soluciones de backup empresarial con recuperación ante desastres.',
  },
  {
    icon: 'ri-image-edit-line',
    title: 'Diseño & Multimedia',
    brand: 'Adobe & Creativos',
    image: 'https://readdy.ai/api/search-image?query=Adobe%20Creative%20Suite%20design%20software%20interface%20on%20a%20modern%20monitor%2C%20Photoshop%20and%20Illustrator%20tools%20visible%2C%20dark%20workspace%20with%20subtle%20teal%20neon%20lighting%2C%20professional%20creative%20studio%2C%20dark%20minimal%20background&width=600&height=400&seq=sw-cat-5&orientation=landscape',
    items: [
      'Adobe Creative Cloud',
      'Adobe Photoshop',
      'Adobe Illustrator',
      'CorelDRAW Graphics Suite',
      'AutoCAD / AutoDesk',
    ],
    description: 'Software profesional de diseño gráfico, edición de imagen, video y modelado 3D con licencias por suscripción o perpetuas.',
  },
  {
    icon: 'ri-mail-send-line',
    title: 'Comunicación & Cloud',
    brand: 'Colaboración Empresarial',
    image: 'https://readdy.ai/api/search-image?query=cloud%20communication%20and%20collaboration%20tools%20interface%20on%20screen%2C%20video%20conferencing%20and%20email%20icons%2C%20dark%20modern%20workspace%20with%20subtle%20cyan%20glow%2C%20professional%20business%20technology%2C%20dark%20minimal%20background&width=600&height=400&seq=sw-cat-6&orientation=landscape',
    items: [
      'Google Workspace Business',
      'Microsoft Teams Premium',
      'Zoom Business / Enterprise',
      'Slack Business+',
      'Dropbox Business',
    ],
    description: 'Plataformas de comunicación, videoconferencia y almacenamiento en la nube para equipos de trabajo distribuidos.',
  },
];

export function LicenseCategories() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="licencias" className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,45,155,0.03),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`text-center mb-14 anim-fade-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Catálogo de <strong className="text-neon-400 text-neon-glow-sm">Licencias</strong>
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            Trabajamos con las principales marcas del mercado para ofrecerte <strong className="text-gray-200">licencias originales</strong> al mejor precio
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat, index) => (
            <article
              key={index}
              className="bg-gray-950/80 rounded-xl border border-gray-800 hover:border-neon-400/30 transition-all duration-300 hover:shadow-neon group hover-lift overflow-hidden"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.title} - Licencias originales de ${cat.brand}`}
                  title={`${cat.title} - ${cat.brand}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-neon-400/10 border border-neon-400/20 rounded-lg group-hover:bg-neon-400/20 transition-all duration-300">
                    <i className={`${cat.icon} text-xl text-neon-400`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-white"><strong>{cat.title}</strong></h3>
                    <p className="text-[11px] text-gray-500">{cat.brand}</p>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mb-4 leading-relaxed">{cat.description}</p>
                <ul className="space-y-1.5">
                  {cat.items.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-xs text-gray-300">
                      <i className="ri-check-line text-neon-400 text-sm"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
